export default "/images/03 Step1Assess-Consultant-To view completed self-assessments-01.png?c47bb5e9a3f5ab71a9526f393ceb43d0";